import { Component, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ReloadService } from './services/reload.service';
import { Enums } from './shared/enums';
import { IMPORTS } from './_imports';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: true,
    imports: IMPORTS
})
export class AppComponent implements OnInit {
    // #region [props]
    isLandingPage = false;
    // #endregion

    // #region [signals]
    $shouldRender = signal(true);
    // #endregion

    constructor(
        public router: Router,
        private reloadService: ReloadService
    ) {
        this.isLandingPage = window?.location?.pathname == Enums.PagesPaths.LandingPage;
    }

    ngOnInit() {
        this.reloadService.reload$.subscribe(() => this.reloadPage());
    }

    reloadPage() {
        this.$shouldRender.set(false);
        setTimeout(() => this.$shouldRender.set(true));
    }
}
